import React from 'react'
import Table from '../../components/common/Table'
import { FriendAndPartnerDTO } from '../../services/apiClient'
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime'
import { renderBooleanBadge } from '../../utils/displayUtils'
import ImagePreview from '../common/ImagePreview'

interface FriendAndPartnerTableProps {
  data: FriendAndPartnerDTO[];
  handleEdit: (row: FriendAndPartnerDTO) => void;
  handleDelete: (row: FriendAndPartnerDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const FriendAndPartnerTable: React.FC<FriendAndPartnerTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Logo',
          key: 'imageFileRecordId',
          width: '80px',
          render: (row: FriendAndPartnerDTO) => (
            <ImagePreview fileId={row.imageFileRecordId} size="sm" />
          ),
        },
        {
          label: 'Name',
          key: 'name',
        },
        {
          label: 'Website URL',
          key: 'websiteUrl',
        },
        {
          label: 'On Dashboard',
          key: 'showOnMemberDashboard',
          render: (row: FriendAndPartnerDTO) => renderBooleanBadge(row.showOnMemberDashboard ?? false),
        },
        {
          label: 'Allow Opt-In',
          key: 'allowOptIn',
          render: (row: FriendAndPartnerDTO) => renderBooleanBadge(row.allowOptIn ?? false),
        },
        {
          label: 'Position',
          key: 'displayPosition',
          width: '80px',
        },
        {
          label: 'Active',
          key: 'isActive',
          render: (row: FriendAndPartnerDTO) => renderBooleanBadge(row.isActive ?? false),
        },
        {
          label: 'Added',
          key: 'createdUtc',
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },
        {
          label: 'Updated',
          key: 'updatedUtc',
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default FriendAndPartnerTable;
